export enum BusinessUnitEnum {
    LGS = 'Logistics (Unyson)',
    HWY = 'Truck Brokerage',
    IML = 'Intermodal'
}
